import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Alert } from '@mui/material';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

const positions = ['coach', 'keeper', 'defender', 'midfielder', 'attacker', 'team'];
const positionLabels = {
    coach: 'Coach',
    keeper: 'Keeper',
    defender: 'Verdediger',
    midfielder: 'Middenvelder',
    attacker: 'Aanvaller',
    team: 'Team'
};

function Scoring() {
    const [rules, setRules] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const fetchRules = useCallback(async () => {
        setLoading(true);
        try {
            const rulesCollection = collection(db, 'scoringRules');
            const snapshot = await getDocs(rulesCollection);
            if (snapshot.empty) {
                setError('Er is nog geen puntentelling ingesteld.');
                setRules([]);
            } else {
                const rulesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                rulesData.sort((a, b) => (a.order || 0) - (b.order || 0));
                setRules(rulesData);
                setError('');
            }
        } catch (err) {
            setError('Fout bij het ophalen van de puntentelling.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchRules();
    }, [fetchRules]);

    if (loading) {
        return <CircularProgress />;
    }

    return (
        <Box>
            <Typography variant="h4" gutterBottom>Puntentelling</Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
                De aanvoerder die je per wedstrijd kiest krijgt 1.5x de normale punten.
            </Typography>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {!loading && !error && rules.length === 0 && (
                <Alert severity="info">De puntentelling is nog niet beschikbaar.</Alert>
            )}
            {rules.length > 0 && (
                <TableContainer component={Paper}>
                    <Table aria-label="scoring rules table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Actie</TableCell>
                                {positions.map(pos => <TableCell key={pos} align="right" sx={{ fontWeight: 'bold' }}>{positionLabels[pos]}</TableCell>)}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rules.map((rule) => (
                                <TableRow key={rule.id} hover>
                                    <TableCell component="th" scope="row">
                                        {rule.action}
                                    </TableCell>
                                    {positions.map(pos => (
                                        <TableCell key={pos} align="right" sx={{
                                            fontWeight: 'bold',
                                            color: rule[pos] > 0 ? 'secondary.main' : rule[pos] < 0 ? 'error.main' : 'text.primary'
                                        }}>
                                            {rule[pos] > 0 ? `+${rule[pos]}` : rule[pos]}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
}

export default Scoring;